import 'new-event-polyfill';
import Vue from 'vue';
import App from './App.vue';
import VueCustomElement from 'vue-custom-element';
import VueCompositionAPI from '@vue/composition-api';
import LineClamp from 'vue-line-clamp';
import Fragment from 'vue-fragment';
import SlideUpDown from 'vue-slide-up-down';

Vue.config.ignoredElements = ['mobile-phones-buttons'];

Vue.use(VueCompositionAPI);
Vue.use(VueCustomElement);
Vue.use(LineClamp);
Vue.use(Fragment.Plugin);
Vue.component('slide-up-down', SlideUpDown);

Vue.customElement('shortlist-app', App);
